"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTheme = exports.themeColors = void 0;
exports.themeColors = {
    primary: {
        50: "#dafffd",
        100: "#b1fbf5",
        200: "#85f6ec",
        300: "#57f1e5",
        400: "#2ceddd",
        500: "#12d3c4",
        600: "#00a498",
        700: "#00766d",
        800: "#004741",
        900: "#001918",
    },
    secondary: {
        50: "#e3fde9",
        100: "#bdf3c9",
        200: "#94e9a7",
        300: "#6be185",
        400: "#43d863",
        500: "#2abe49",
        600: "#1e9438",
        700: "#136a27",
        800: "#073f16",
        900: "#001702",
    },
};
exports.defaultTheme = {
    fonts: {
        heading: "Montserrat, sans-serif",
        body: "Montserrat, sans-serif",
        mono: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
    },
    colors: exports.themeColors,
};
